import styled from "styled-components";

import { FlexDiv, Button, Box } from "../../../../components/Atoms";

export const StyledVideoOverlay = styled(Box)`
  padding: 24px;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${({ theme }) => theme.colorsV2.gray.shade_900};
  background-image: ${({ bgImg }) => bgImg};
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  transition: all 0.3s ease-in-out;
`;

export const OverlayContent = styled(Box)`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

export const StyledAction = styled(FlexDiv)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  p {
    display: flex;
    align-items: center;
    text-align: center;
  }
`;
